// @flow
import React from 'react'
import { Cover } from 'components/cover/base'

import { srcSetConfiguration } from '../srcsets/'
import type { BaseCoverProps, VideoCoverProps } from 'components/cover/types'
import { browserCheck } from '@ta-interaktiv/js-toolbox'

export function VideoCover (props: BaseCoverProps & VideoCoverProps) {
  const supportsObjectFit =
    window.CSS &&
    window.CSS.supports &&
    window.CSS.supports('object-fit', 'cover')
  const isMobile = browserCheck.isMobile || browserCheck.isTablet
  const isIOS9 = /iPhone OS [6789]_/.test(navigator.userAgent)

  return (
    <Cover {...props}>
      {!isIOS9 &&
        !browserCheck.isAndroidNativeApp && (
          <video
            autoPlay
            muted
            playsInline
            preload
            loop
            className='poster image'
            poster={props.poster.sources['1200w']}
            ref={video => {
              if (video) {
                video.setAttribute('playsinline', '')
              }
            }}
          >
            {!isMobile && (
              <source src={props.video.webm.desktop} type='video/webm' />
            )}

            {isMobile && (
              <source src={props.video.webm.mobile} type='video/webm' />
            )}

            {!isMobile && (
              <source src={props.video.mp4.desktop} type='video/mp4' />
            )}

            {isMobile && (
              <source src={props.video.mp4.mobile} type='video/mp4' />
            )}

            {supportsObjectFit && (
              <img
                style={{
                  height: props.coverHeight
                }}
                className='poster image'
                src={props.poster.sources['600w']}
                srcSet={props.poster.srcSet}
                sizes={srcSetConfiguration.fullWidthSizeHint}
                alt=''
              />
            )}

            {!supportsObjectFit && (
              <div
                className='poster fallback'
                style={{
                  height: props.coverHeight,
                  backgroundImage: `url(${props.poster.sources['1200w']})`
                }}
              />
            )}
          </video>
        )}
    </Cover>
  )
}



// WEBPACK FOOTER //
// ./src/components/cover/video.js